<template>
<div class="row plain-element">
  <div v-if="!isLoggedIn()" class="dashboard-cards">
    <NoPermissionComponent/>
  </div>
  <div v-if="getUsername()" class="dashboard" v-cloak>
    <div  class="dashboard-cards">
      <div class="row row-title">
        <div class="">
          <h4 class=" underline-blue"> Update Successful </h4>
        </div>
      </div>
      <div class="row plain-element">
        <div>
          <div class="row plain-element text-center">
              <router-link :to="{name: 'user-profile'}" type="submit" class="btn btn-success">Go to Profile</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>


<script>
import { mapGetters } from "vuex";
import NoPermissionComponent from "@/components/NoPermissionComponent.vue";


export default {
  name: "UserProfileSuccess",
  components: {
    NoPermissionComponent,

  },
  data() {
    return {

    }
  },

  methods: {
    ...mapGetters(["getUsername", "isLoggedIn"]),
  },
  created() {
    document.title = "Success";
    window.scrollTo(0,0);
  }
}


</script>
